<pux-translate :text="textZuschussTranslate" :extra="extraForTranslate"></pux-translate>